/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

// COMMON Imports
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import SearchBarWithCTA from "../../CommonSearchComponents/SearchBarWithCTA";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";
import SingleSelectDropDownComponent from "../../CommonDropdown/SingleSelectDropdown";
import SecondaryRightIconSmallButton from "../../CommonButtons/SecondaryRightIconSmallButton";
import PrimaryButton from "../../CommonButtons/PrimaryButton";
import SwitcherTabs from "../../CommonButtons/SwitcherTabs";
import Chips from "../../CommonButtons/Chips";
import CommonCountMultiSelect from "../../NumberCountComponent/CommonCountMultiSelect";

// REDUX Imports
import { ownerViewAllAcc } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import { getUsers } from "../../../../redux/features/Settings/Management/Users";

// SVG Imports
// REDUX Imports
import { formatAccountNumber } from "../../../_utils/FormatAccountNumber";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../CommonToast";

/**
 * CommonAssignTagPopup Component - A popup component for assigning/unassigning tags to users or owner accounts
 *
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 *
 * @param {Object} props
 * @param {string} props.headerTitle - Main title text to display at the top of popup
 * @param {OnClickEventHandler} [props.closehandleFunction] - Handle function when close button is clicked
 * @param {string} [props.closedisabledBgColor] - Background color when close button is disabled (CSS variable)
 * @param {React.RefObject} [props.closebuttonRef] - Button ref for close button (optional)
 * @param {string} [props.closeimgColor] - Icon color for close button (CSS variable)
 * @param {React.RefObject} [props.ctabtnRef] - Button ref for CTA button in search bar (optional)
 * @param {boolean} [props.loading] - Loading state for tags data
 * @param {Array} props.newTags - Array of assigned tags (tags that are currently assigned)
 * @param {OnClickEventHandler} [props.onClose] - Callback function when popup is closed
 * @param {Function} [props.handleAddTags] - Function to handle adding new tags
 * @param {Function} [props.handleRemoveTags] - Function to handle removing tags
 * @param {Function} props.setNewTags - Setter function to update assigned tags array
 * @param {Array} props.AllTags - Array of all available tags (unassigned tags)
 * @param {Function} props.setAllTags - Setter function to update all tags array
 * @param {Function} [props.setLoading] - Setter function to update loading state
 * @param {boolean} [props.users] - Boolean to indicate if component is for users (true) or owner accounts (false)
 * @param {string|number} [props.id] - ID of the current user/owner
 * @param {Array} props.ownerDetailData - Array of owner/user detail objects
 * @param {string} props.type - Type of view: "ownerDetails", "ownerViewAll", "userViewAll"
 * @param {string|number} [props.selectedAssignedAccountID] - Currently selected assigned account/user ID
 * @param {Function} props.setSelectedAssignedAccountID - Setter function to update selected assigned account ID
 * @param {string} props.selectedAccount - Currently selected account/user name or "All selected accounts"/"All selected users"
 * @param {Function} props.setSelectedAccount - Setter function to update selected account
 * @param {Array} [props.existingTags] - Array of existing tags
 * @param {Function} [props.setExistingTags] - Setter function to update existing tags
 * @param {Array} [props.ownerExistingTag] - Array of owner's existing tags
 * @param {Function} [props.getOwnerDetaildata] - Function to fetch owner detail data
 * @returns {JSX.Element}
 */
const CommonAssignTagPopup = ({
  headerTitle,
  closehandleFunction,
  closedisabledBgColor,
  closebuttonRef,
  closeimgColor,
  ctabtnRef,
  loading,
  newTags,
  onClose,
  handleAddTags,
  handleRemoveTags,
  setNewTags,
  AllTags,
  setAllTags,
  setLoading,
  users,
  ownerDetailData,
  type,
  setSelectedAssignedAccountID,
  selectedAccount,
  setSelectedAccount,
  dummyUser,
  description,
  typeForSpaces,
}) => {
  // useDispatch
  const dispatch = useDispatch();

  // useRef
  const dropdownRef = useRef(null);
  const tagInputRef = useRef("");

  // useState
  const [tagSearchName, setTagSearchName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectAll, setselectAll] = useState(false);
  const [selectAll1, setselectAll1] = useState(false);
  const [icon, setIcon] = useState(ICONS?.ARROW_UP_WHITE);
  const [icon1, setIcon1] = useState(ICONS?.ARROW_UP_WHITE);
  const [filteredExistingTags, setfilteredExistingTags] = useState([]);
  const [filteredExistingTags1, setfilteredExistingTags1] = useState([]);
  const [tagsCountLoader, setTagsCountLoader] = useState(false);
  const [tagsCountLoader1, setTagsCountLoader1] = useState(false);
  const [showHideOne, setShowHideOne] = useState(false);
  const [showHideTwo, setShowHideTwo] = useState(false);
  const [showAssignTag, setshowAssignTag] = useState(true);
  const [showUnassignTag, setshowUnassignTag] = useState(false);
  const [animate, setAnimate] = useState(false);

  // useSelector
  const services = useSelector((state) => state.refreshToken.services);

  // useEffect
  useEffect(() => {
    const handleDropDown = (e) => {
      if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
      } else {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleDropDown);
    document.addEventListener("mousedown", handleDropDown);
    return () => {
      document.removeEventListener("click", handleDropDown);
      document.removeEventListener("mousedown", handleDropDown);
    };
  }, [dropdownRef]);

  useEffect(() => {
    setTagsCountLoader(true);
    setfilteredExistingTags(
      newTags?.filter((tag) => {
        return (
          (tag?.type === "existingTag" ||
            tag?.type === "ownerTags" ||
            tag?.type === "Available") &&
          normalize(tag?.value).includes(normalize(tagSearchName))
        );
      }),
    );
    setTimeout(() => {
      setTagsCountLoader(false);
    }, 600);
  }, [newTags, tagSearchName]);

  useEffect(() => {
    setTagsCountLoader1(true);
    setfilteredExistingTags1(
      AllTags?.filter((tag) => {
        return (
          (tag?.type === "Available" ||
            tag?.type === "ownerTags" ||
            tag?.type === "Available") &&
          normalize(tag?.value).includes(normalize(tagSearchName)) &&
          !newTags.some((assignedTag) => assignedTag.value === tag.value)
        );
      }),
    );
    setTimeout(() => {
      setTagsCountLoader1(false);
    }, 600);
  }, [AllTags, tagSearchName]);

  useEffect(() => {
    if (dummyUser) {
      return;
    } else if (users) {
      handleuserAll();
    } else {
      HandleAllTags();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < ScreenSizeConfiguration.tabviewEnd) {
        setshowAssignTag(true);
        setshowUnassignTag(false);
      } else {
        setshowUnassignTag(true);
        setshowAssignTag(true);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const allowSpacesAndCaps = typeForSpaces === "privateTxn";

  const normalize = (val = "") =>
    allowSpacesAndCaps
      ? val.toLowerCase()
      : val.replace(/\s+/g, "").toLowerCase();

  const handleClick = () => {
    setIcon(
      icon === ICONS?.ARROW_UP_WHITE
        ? ICONS?.ARROW_DOWN_WHITE
        : ICONS?.ARROW_UP_WHITE,
    );
    setShowHideOne(!showHideOne);
  };

  const handleClick1 = () => {
    setIcon1(
      icon1 === ICONS?.ARROW_UP_WHITE
        ? ICONS?.ARROW_DOWN_WHITE
        : ICONS?.ARROW_UP_WHITE,
    );
    setShowHideTwo(!showHideTwo);
  };

  const handleAccountSelect = (account, e) => {
    const textContent = e?.target?.textContent || account;
    if (textContent !== selectedAccount) {
      setSelectedAccount(
        textContent === "All selected accounts" ||
          textContent === "All selected users"
          ? textContent
          : account,
      );
      setselectAll1(false);
      setIcon(ICONS?.ARROW_UP_WHITE);
      setIcon1(ICONS?.ARROW_UP_WHITE);
      setselectAll(false);

      let selectedOwnerId;
      if (users) {
        selectedOwnerId = ownerDetailData?.find(
          (owner) => owner?.id === account,
        )?.id;
      } else {
        selectedOwnerId = ownerDetailData?.find(
          (owner) => owner?.bank_acc_no === account,
        )?.id;
      }
      setSelectedAssignedAccountID(
        textContent === "All selected accounts" ||
          textContent === "All selected users"
          ? ""
          : selectedOwnerId,
      );
    }
    setIsDropdownOpen(false);
  };

  const result = newTags?.filter((tag) => {
    return normalize(tag?.value) === normalize(tagSearchName);
  });

  const result1 = AllTags?.filter((tag) => {
    return normalize(tag?.value) === normalize(tagSearchName);
  });

  const handleSearchInput = (value) => {
    let processedValue = value || "";

    if (!allowSpacesAndCaps) {
      processedValue = processedValue.replace(/\s+/g, "").toLowerCase();
    }
    processedValue = processedValue.substring(
      GlobalConfiguration?.lengthCheckZero,
      GlobalConfiguration?.inputValidationLength,
    );
    setTagSearchName(processedValue);
  };

  const trimmedTag = tagSearchName?.trim() || "";
  const isTagLengthValid =
    trimmedTag.length >= GlobalConfiguration?.searchMinLength &&
    trimmedTag.length <= GlobalConfiguration?.inputValidationLength;

  const isTagNotExisting =
    result?.length === GlobalConfiguration.lengthCheckZero &&
    result1?.length === GlobalConfiguration.lengthCheckZero;

  const isTagInputValid = isTagLengthValid && isTagNotExisting;

  const handleAssignTrue = () => {
    setshowAssignTag(true);
    setshowUnassignTag(false);
  };
  const handleUnassignTrue = () => {
    setshowAssignTag(false);
    setshowUnassignTag(true);
  };

  const clearTags = () => {
    if (!newTags || !Array.isArray(newTags)) {
      return;
    }
    const updatedTags = newTags?.map((tag) => ({
      ...tag,
      selected: type,
    }));

    setNewTags(updatedTags);
    setselectAll(false);
    setShowHideOne(false);
    setIcon(ICONS?.ARROW_UP_WHITE);
  };

  const clearTags1 = () => {
    if (!AllTags || !Array.isArray(AllTags)) {
      return;
    }
    const updatedTags = AllTags?.map((tag) => ({
      ...tag,
      selected: type,
    }));

    setAllTags(updatedTags);
    setselectAll1(false);
    setShowHideTwo(false);
    setIcon1(ICONS?.ARROW_UP_WHITE);
  };

  const handleExistingTag = (selectedTag) => {
    const updatedTags = newTags?.map((tag) => {
      if (tag.value === selectedTag && tag.type !== "newTag") {
        return { ...tag, selected: !tag.selected };
      } else {
        return tag;
      }
    });

    setNewTags(updatedTags);
    const allSelected = updatedTags.every((tag) => !tag.selected);

    setselectAll(allSelected);
  };

  const selectedValue = () => {
    const type = selectAll;
    if (tagSearchName.trim().length > GlobalConfiguration.lengthCheckZero) {
      const updatedTags = JSON.parse(JSON.stringify(newTags))?.map((tag) => {
        if (
          filteredExistingTags?.some(
            (filteredTag) => filteredTag.value === tag.value,
          )
        ) {
          return { ...tag, selected: type };
        } else {
          return { ...tag };
        }
      });
      setNewTags(updatedTags);
    } else {
      const updatedTags = newTags?.map((tag) => ({
        ...tag,
        selected:
          tagSearchName.trim().length > GlobalConfiguration.lengthCheckZero
            ? filteredExistingTags?.value
              ? false
              : true
            : type,
      }));

      setNewTags(updatedTags);
    }

    setselectAll((prev) => !prev);
  };

  const selectedValue1 = () => {
    const type = selectAll1;
    if (tagSearchName.trim().length > GlobalConfiguration.lengthCheckZero) {
      const updatedTags = JSON.parse(JSON.stringify(AllTags))?.map((tag) => {
        if (
          filteredExistingTags1?.some(
            (filteredTag) => filteredTag.value === tag.value,
          )
        ) {
          return { ...tag, selected: type };
        } else {
          return { ...tag };
        }
      });
      setAllTags(updatedTags);
    } else {
      const updatedTags = AllTags?.map((tag) => ({
        ...tag,
        selected:
          !filteredExistingTags.some((a) => {
            return a.value === tag.value;
          }) && !selectAll1
            ? false
            : true,
      }));
      setAllTags(updatedTags);
    }

    setselectAll1((prev) => !prev);
  };

  const handleExistingTag1 = (selectedTag) => {
    const updatedTags = AllTags.map((tag, id) => {
      if (tag?.value === selectedTag) {
        return { ...tag, selected: !tag.selected };
      } else {
        return tag;
      }
    });
    setAllTags(updatedTags);
    const allSelected = updatedTags.every((tag) => !tag.selected);

    setselectAll1(allSelected);
  };

  const handleNewTag = (item) => {
    setIcon(ICONS?.ARROW_UP_WHITE);
    setIcon1(ICONS?.ARROW_UP_WHITE);
    const tagExists = newTags?.some(
      (tag) => normalize(tag?.value) === normalize(tagSearchName),
    );

    if (tagExists) {
    } else {
      if (handleAddTags) {
        handleAddTags(item);
      }
      setTagSearchName("");
      setselectAll(false);
    }
  };

  const handleSelectandDeselect = (selectedTag) => {
    const updatedTags = newTags?.reduce((acc, res) => {
      if (res.value === selectedTag) {
        return [...acc, { ...res, selected: true }];
      } else {
        return [...acc, res];
      }
    }, []);

    const updatedTags1 = newTags?.map((acc) => {
      return {
        data: !acc?.selected,
      };
    });

    const trueCount = updatedTags1?.reduce(
      (count, item) => count + (item.data ? 1 : 0),
      0,
    );

    if (trueCount === 1) {
      setIcon(ICONS?.ARROW_UP_WHITE);
      setShowHideOne(false);
    }

    setNewTags(updatedTags);
    setselectAll(false);
  };

  const handleSelectandDeselect1 = (selectedTag) => {
    const updatedTags = AllTags?.reduce((acc, res) => {
      if (res.value === selectedTag) {
        return [...acc, { ...res, selected: true }];
      } else {
        return [...acc, res];
      }
    }, []);

    const updatedTags1 = AllTags?.map((acc) => {
      return {
        data: !acc?.selected,
      };
    });

    const trueCount = updatedTags1?.reduce(
      (count, item) => count + (item.data ? 1 : 0),
      0,
    );

    if (trueCount === 1) {
      setIcon1(ICONS?.ARROW_UP_WHITE);
      setShowHideTwo(false);
    }

    setAllTags(updatedTags);
    setselectAll1(false);
  };

  const handleuserAll = async () => {
    if (setLoading) {
      setLoading(true);
    }

    try {
      let response = await dispatch(getUsers({ page_no: 1, page_size: 50 }));
      if (response?.payload?.status === true) {
        const data = response?.payload?.available_tags?.map((res) => {
          return { selected: true, value: res, type: "Available" };
        });
        if (type !== "userViewAll" || type !== "ownerViewAll") {
          setAllTags(data);
        }
        if (setLoading) {
          setLoading(false);
        }
      } else {
        if (setLoading) {
          setLoading(false);
        }
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      if (setLoading) {
        setLoading(false);
      }
    }
  };

  const HandleAllTags = async () => {
    try {
      let response = await dispatch(
        ownerViewAllAcc({ page_no: 1, page_size: 50 }),
      );

      if (response?.payload?.status === true) {
        const data = response?.payload?.summary?.available_tags?.map((res) => {
          return { selected: true, value: res, type: "Available" };
        });

        if (type !== "ownerViewAll") {
          setAllTags(data);
        }
        if (setLoading) {
          setLoading(false);
        }
      } else {
        if (setLoading) {
          setLoading(false);
        }
      }
    } catch (error) {
      if (setLoading) {
        setLoading(false);
      }
    }
  };

  const handleUnassign = async () => {
    const remainingTags = newTags.filter((tag) => !tag.selected);
    const data = remainingTags.map((tag) => {
      return tag.value;
    });

    if (handleRemoveTags) {
      await handleRemoveTags(data);
    }
    if (!users) {
      await HandleAllTags();
    }

    if (selectAll) {
      setselectAll(false);
    }
    setShowHideOne(false);
    setIcon(ICONS?.ARROW_UP_WHITE);
  };

  const handleAssign = () => {
    const selectedTags = AllTags?.filter((tag) => tag.selected);
    const remainingTags = AllTags?.filter((tag) => !tag.selected);

    const data1 = remainingTags?.map((tag) => {
      return tag.value;
    });

    if (dummyUser) {
      handleAddTags(remainingTags);
    } else if (handleAddTags) {
      handleAddTags({ data1, type: "newAss" });
    }

    setAllTags(selectedTags);

    if (selectAll1) {
      setselectAll1(false);
    }
    setShowHideTwo(false);
    setIcon1(ICONS?.ARROW_UP_WHITE);
  };

  const isAnyTagDeselected = newTags?.some((tag) => tag.selected === false);
  const isAnyTagDeselectedUnassign = AllTags?.some(
    (tag) => tag.selected === false,
  );

  const handleKeyPress = (e) => {
    if (users && !services?.includes("CTag")) {
      return;
    } else if (!users && !services?.includes("COwnerTag")) {
      return;
    } else {
      if (e.key === "Enter") {
        const inputValue = e.target.value;
        if (inputValue.trim()) {
          handleNewTag(inputValue);
        }
      }
    }
  };

  const toSentenceCase = (text = "") =>
    text.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
    text.slice(GlobalConfiguration?.lengthCheckOne).toLowerCase();

  return (
    <div
      className="flex w-full justify-center items-center m-auto top-1/2 left-1/2 fixed z-z-index-modal p-padding-sm"
      style={{ transform: "translate(-50%, -50%)" }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`h-fit w-full h-popup-height Qsmd:max-h-assign-tag-popup-height overflow-hidden relative Qmd:w-max-content-width flex flex-col pt-padding-md bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"}`}
      >
        <div className="flex flex-col flex-1 overflow-hidden">
          <div className=" flex flex-col gap-gap-xs px-padding-md">
            <div className="flex justify-between gap-gap-md ">
              <div className=" flex gap-gap-sm">
                {" "}
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-font-md text-text-primary font-semibold">
                    {toSentenceCase(headerTitle)}
                  </p>
                  <span className="font-normal text-text-secondary text-font-xs">
                    {description?.headerDescription
                      ? description?.headerDescription
                      : users
                        ? "Tagged users will gain access to view only owner accounts that share the same tags."
                        : "Tagged owner accounts will be visible to the users who share  the same tags."}
                  </span>
                </div>
              </div>
              <IconRoundButton
                enabledBgColor={"var(--primary-nav-act)"}
                isLoading={false}
                handleFunction={() => {
                  setAnimate(true);
                  setTimeout(() => {
                    closehandleFunction();
                  }, IntervalConfiguration.intervalSemiMid);
                }}
                title="Close"
                icon={
                  "https://q2pay.in/new_assets/common/create_flow/close.svg"
                }
                hoverOption="white"
                btnType={"button"}
                isDisabled={false}
                disabledBgColor={closedisabledBgColor}
                buttonRef={closebuttonRef}
                imgColor={closeimgColor}
              />
            </div>
          </div>

          <div className=" flex flex-col Qmd:flex-row Qmd:items-center pt-padding-md px-padding-md  gap-gap-sm Qmd:gap-gap-md w-full ">
            <div
              ref={dropdownRef}
              className="w-full  Qmd:w-width-sm max-w-full Qmd:max-w-assign-tag-dropdown flex-shrink-0"
              style={{ display: dummyUser ? "none" : "block" }}
            >
              <SingleSelectDropDownComponent
                options={
                  type === "ownerDetails" || ownerDetailData?.length === 1
                    ? []
                    : (type === "ownerViewAll" || type === "userViewAll") &&
                        ownerDetailData?.length > 1
                      ? users
                        ? ownerDetailData?.map(
                            (account) =>
                              account?.first_name +
                              " " +
                              (account?.last_name ?? ""),
                          )
                        : ownerDetailData?.map(
                            (account) => account?.bank_acc_no,
                          )
                      : []
                }
                selected={
                  type === "ownerDetails" || ownerDetailData?.length === 1
                    ? users
                      ? users
                      : formatAccountNumber(
                          Array.isArray(ownerDetailData)
                            ? ownerDetailData[0]?.bank_acc_no
                            : ownerDetailData?.bank_acc_no,
                        )
                    : selectedAccount !== "All selected accounts"
                      ? users
                        ? ownerDetailData?.find(
                            (owner) => owner?.id === selectedAccount,
                          )?.first_name +
                          " " +
                          (ownerDetailData?.find(
                            (owner) => owner?.id === selectedAccount,
                          )?.last_name ?? "")
                        : selectedAccount
                      : users
                        ? "All selected users"
                        : "All selected accounts"
                }
                setSelected={(val) => {
                  if (!val) {
                    setselectAll1(false);
                    setselectAll(false);
                    setIsDropdownOpen(false);
                    setSelectedAssignedAccountID("");
                    setSelectedAccount("All selected accounts");
                  } else if (val !== selectedAccount) {
                    if (users) {
                      const selectedOwner = ownerDetailData?.find(
                        (owner) =>
                          owner?.first_name + " " + (owner?.last_name ?? "") ===
                          val,
                      );
                      if (selectedOwner) {
                        handleAccountSelect(selectedOwner?.id, {
                          target: { textContent: val },
                        });
                      }
                    } else {
                      const selectedOwner = ownerDetailData?.find(
                        (owner) => owner?.bank_acc_no === val,
                      );
                      if (selectedOwner) {
                        handleAccountSelect(selectedOwner?.bank_acc_no, {
                          target: { textContent: val },
                        });
                      }
                    }
                  }
                }}
                type="small"
                placeholder={
                  type === "ownerDetails" || ownerDetailData?.length === 1
                    ? users
                      ? users
                      : formatAccountNumber(
                          Array.isArray(ownerDetailData)
                            ? ownerDetailData[0]?.bank_acc_no
                            : ownerDetailData?.bank_acc_no,
                        )
                    : users
                      ? "All selected users"
                      : "All selected accounts"
                }
                showSearch={false}
                disabled={
                  type === "ownerDetails" || ownerDetailData?.length === 1
                }
                onOpen={() => {
                  setIsDropdownOpen(true);
                }}
                isOpen={isDropdownOpen}
                onClose={() => {
                  setIsDropdownOpen(false);
                }}
              />
            </div>
            <div className=" flex-1">
              <SearchBarWithCTA
                btnText={
                  users && !services?.includes("CTag")
                    ? "Search tag"
                    : !users && !services?.includes("COwnerTag")
                      ? "Search tag"
                      : "Assign new tag"
                }
                txtColor={"var(--text-primary)"}
                placeholder={
                  description?.searchPlaceholderDescription
                    ? description?.searchPlaceholderDescription
                    : users && !services?.includes("CTag")
                      ? "Search tag"
                      : !users && !services?.includes("COwnerTag")
                        ? "Search tag"
                        : "Search / Enter new tag"
                }
                searchText={tagSearchName}
                inActiveVariantNeeded={!isTagInputValid}
                onInput={handleSearchInput}
                onKeyDown={handleKeyPress}
                onClick={() => {
                  if (!isTagInputValid) return;
                  handleNewTag(trimmedTag);
                }}
                disabledBtnColor={"var(--text-disabled)"}
                disabledTxtColor={"var(--text-primary)"}
                disabledBgColor={"var(--text-disabled)"}
                disabledTextColor={"var(--text-primary)"}
                isBtnDisable={!isTagInputValid}
                searchRef={tagInputRef}
                isSearchDisabled={false}
                btnColor={
                  isTagInputValid
                    ? "var(--positive-act)"
                    : "var(--text-disabled)"
                }
                btnRef={ctabtnRef}
                hoverOption={"black"}
                dummyUser={dummyUser}
              />
            </div>
          </div>
          <div className="flex w-full lg:hidden px-padding-md pt-padding-md">
            <SwitcherTabs
              initialActiveTab={showAssignTag ? "Assigned" : "Unassigned"}
              tabs={[
                {
                  label: `Assigned - ${filteredExistingTags?.length || GlobalConfiguration.lengthCheckZero}`,
                  handler: handleAssignTrue,
                  key: "Assigned",
                },
                {
                  label: `Unassigned - ${filteredExistingTags1?.length || GlobalConfiguration.lengthCheckZero}`,
                  handler: handleUnassignTrue,
                  key: "Unassigned",
                },
              ]}
            />
          </div>
          <div className="w-full flex flex-row mt-margin-md bg-primary-card  flex-1 overflow-y-hidden max-h-full overflow-x-hidden">
            <div
              className={`h-full w-full relative lg:flex flex-col ${
                users && !services?.includes("DTag")
                  ? "bg-PopUp-BackDrop opacity-light-opacity z-z-index-overlay pointer-events-none"
                  : !users && !services?.includes("DOwnerTag")
                    ? "bg-PopUp-BackDrop opacity-light-opacity z-z-index-overlay pointer-events-none"
                    : AllTags?.some((tag) => {
                          return tag.selected === false;
                        })
                      ? "bg-PopUp-BackDrop opacity-light-opacity z-z-index-overlay pointer-events-none"
                      : ""
              } ${showAssignTag ? "flex" : "hidden"} `}
            >
              <div className=" flex flex-col gap-gap-xs px-padding-md pt-padding-md  ">
                <div className="flex justify-between gap-gap-md ">
                  <div className=" flex gap-gap-sm">
                    {" "}
                    <div className="flex flex-col gap-gap-xs">
                      <p className="text-font-md text-text-primary font-semibold flex items-center justify-start">
                        {description?.title1
                          ? description?.title1
                          : "Assigned tags"}{" "}
                        -{" "}
                        {filteredExistingTags?.length ||
                          GlobalConfiguration.lengthCheckZero}
                      </p>
                      {filteredExistingTags?.length >
                      GlobalConfiguration.lengthCheckZero ? (
                        <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                          {description?.title4
                            ? description?.title4
                            : users
                              ? 'Select tag(s) and click "Unassign" to unlink them from the user(s).'
                              : 'Select tag(s) and click "Unassign" to unlink them from the owner account(s).'}
                        </span>
                      ) : filteredExistingTags?.length ===
                          GlobalConfiguration.lengthCheckZero &&
                        !AllTags?.some((e) =>
                          normalize(e.value)?.includes(
                            normalize(tagSearchName),
                          ),
                        ) ? (
                        <span
                          className={` ${description?.title6 ? "invisible" : ""} font-normal text-text-secondary text-font-xs pb-padding-sm`}
                        >
                          Click on 'Assign new tag' to assign the tag entered
                          above.
                        </span>
                      ) : newTags?.length ===
                        GlobalConfiguration.lengthCheckZero ? (
                        <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                          {description?.zeroValueDescription
                            ? description?.zeroValueDescription
                            : ` To assign a tag, either select from the list of
                          unassigned tags and assign them or type a new tag name
                          in the search bar and click 'Assign new tag'.`}
                        </span>
                      ) : (
                        <span
                          className="font-normal text-text-secondary text-font-xs pb-padding-sm"
                          style={{
                            visibility: "hidden",
                          }}
                        >
                          Click on 'Assign new tag' to assign the tag entered
                          above.
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex-shrink-0 ">
                    <SecondaryRightIconSmallButton
                      btnText="Select all"
                      btnType="button"
                      handleFunction={
                        icon === ICONS?.ARROW_DOWN_WHITE ||
                        filteredExistingTags?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? () => {}
                          : selectedValue
                      }
                      isDisabled={
                        icon === ICONS?.ARROW_DOWN_WHITE ||
                        loading ||
                        filteredExistingTags?.length ===
                          GlobalConfiguration.lengthCheckZero
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor={
                        selectAll &&
                        filteredExistingTags?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-bg)"
                          : "var(--primary-nav)"
                      }
                      hoverOption={
                        selectAll &&
                        filteredExistingTags?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "black"
                          : "white"
                      }
                      icon={
                        selectAll &&
                        filteredExistingTags?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className=" flex flex-col relative gap-gap-xs pl-padding-md pt-padding-md flex-1 overflow-hidden">
                {loading ? (
                  <>
                    <div className="flex justify-center items-center h-full ">
                      <img
                        src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                        alt="loading"
                        className={` w-icon-lg h-icon-lg`}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    {newTags?.length > GlobalConfiguration.lengthCheckZero &&
                    filteredExistingTags?.length >
                      GlobalConfiguration.lengthCheckZero &&
                    !loading ? (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pr-padding-md pb-padding-sm  Qsmd:max-h-full overflow-x-hidden">
                        {newTags?.length >
                          GlobalConfiguration.lengthCheckZero &&
                          newTags
                            ?.filter((fil) => {
                              return normalize(fil.value).includes(
                                normalize(tagSearchName),
                              );
                            })
                            ?.map((tag) => {
                              return (
                                // <PrimaryWithIconButton
                                //   key={tag?.value}
                                //   handleFunction={() =>
                                //     handleExistingTag(tag.value)
                                //   }
                                //   btnText={tag.value}
                                //   btnType="button"
                                //   isDisabled={false}
                                //   enabledBgColor={
                                //     tag.selected === false
                                //       ? "var(--positive-card)"
                                //       : "var(--primary-nav-act)"
                                //   }
                                //   isLoading={false}
                                //   hoverOption={
                                //     tag.selected === false ? "black" : "white"
                                //   }
                                //   enabledTextColor="var(--text-primary)"
                                //   icon={
                                //     tag.selected === false
                                //       ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                //       : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                                //   }
                                //   iconToBeAlign="right"
                                //   fullWidthRequired={false}
                                // />
                                <Chips
                                  key={tag?.value}
                                  txtChip={tag.value}
                                  icon={
                                    tag.selected === false
                                      ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                      : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                                  }
                                  hoverOptionBtn={
                                    tag.selected === false ? "black" : "white"
                                  }
                                  enabledBgColor={
                                    tag.selected === false
                                      ? "var(--positive-card)"
                                      : "var(--primary-nav-act)"
                                  }
                                  isDisabled={false}
                                  handleFunctionBtn={() =>
                                    handleExistingTag(tag.value)
                                  }
                                  enabledTextColor="var(--text-primary)"
                                  isTickerRequired={true}
                                />
                              );
                            })}
                      </div>
                    ) : (
                      <div className="flex flex-col justify-center items-center gap-gap-sm py-padding-md flex-1  h-full">
                        {!loading &&
                        filteredExistingTags?.length ===
                          GlobalConfiguration.lengthCheckZero &&
                        tagSearchName.length >
                          GlobalConfiguration.lengthCheckZero ? (
                          <>
                            <img
                              className="h-graphic-square-height-sm  "
                              src={
                                "https://q2pay.in/new_assets/graphics/general/assign.svg"
                              }
                              alt="nolablefound"
                            />
                            <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                              {description?.title7
                                ? description?.title7
                                : "No assigned tags found."}
                            </p>
                          </>
                        ) : (
                          !loading && (
                            <>
                              <img
                                className="h-graphic-square-height-sm  "
                                src={
                                  "https://q2pay.in/new_assets/graphics/general/assign.svg"
                                }
                                alt="nolablefound"
                              />
                              <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                                {description?.title7
                                  ? description?.title7
                                  : "No assigned tags found."}
                              </p>
                            </>
                          )
                        )}
                      </div>
                    )}
                  </>
                )}

                <div
                  className={`absolute ${showHideOne ? "top-0" : "top-full"} overflow-y-auto w-full left-0 h-full bg-primary-nav transition-all duration-500  ease-in-out border-b-border border-primary-bg`}
                >
                  {icon === ICONS?.ARROW_DOWN_WHITE ? (
                    <div className="flex gap-gap-sm flex-wrap overflow-y-auto pl-padding-md pt-padding-md pr-padding-md pb-padding-sm max-h-full">
                      {newTags?.map((tag) => {
                        return (
                          <>
                            {!tag.selected && (
                              <Chips
                                key={tag?.value}
                                txtChip={tag.value}
                                icon={
                                  "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                                }
                                hoverOption="white"
                                enabledBgColor="var(--primary-nav-act)"
                                handleFunction={() =>
                                  handleSelectandDeselect(tag.value)
                                }
                                enabledTextColor="var(--text-primary)"
                              />
                            )}
                          </>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="w-full flex justify-between  relative bg-primary-nav  p-padding-md rounded-bl-border-radius-md z-z-index-header">
                <div className="flex gap-gap-sm items-center">
                  <CommonCountMultiSelect
                    bgColor={"bg-primary-bg"}
                    textColor={"text-text-primary"}
                    count={
                      !loading
                        ? newTags?.filter((fil) => !fil.selected)?.length ||
                          GlobalConfiguration.lengthCheckZero
                        : GlobalConfiguration.lengthCheckZero
                    }
                  />
                  <p className="text-text-primary text-font-sm font-normal hidden Qsmd:block">
                    {description?.title5 ? description?.title5 : "Selected"}
                  </p>
                </div>
                <div className="flex flex-row-reverse gap-gap-sm">
                  <div>
                    <PrimaryButton
                      btnText={"Unassign"}
                      btnType={"button"}
                      handleFunction={() => {
                        if (
                          isAnyTagDeselected &&
                          !loading &&
                          !tagSearchName?.length
                        ) {
                          handleUnassign();
                        }
                      }}
                      isDisabled={
                        !isAnyTagDeselected || loading || tagSearchName?.length
                      }
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--positive-act)"}
                      disabledBgColor={"var(--text-disabled)"}
                      hoverOption={"black"}
                      isLoading={false}
                      inActiveVariantNeeded={!isAnyTagDeselected || loading}
                      isLoaderNeeded={false}
                    />
                  </div>

                  <PrimaryButton
                    btnText={"Clear"}
                    handleFunction={() => {
                      if (
                        isAnyTagDeselected &&
                        !loading &&
                        !tagSearchName?.length
                      ) {
                        clearTags();
                      }
                    }}
                    isDisabled={!isAnyTagDeselected || tagSearchName?.length}
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"transparent"}
                    outLineColor={"var(--text-primary)"}
                    hoverOption="white"
                    btnType="button"
                    isLoading={false}
                    inActiveVariantNeeded={false}
                    isLoaderNeeded={false}
                  />
                  <div className=" border-l-border border-primary-bg"></div>
                  <PrimaryWithIconButton
                    handleFunction={
                      newTags?.filter((fil) => !fil.selected).length ===
                      GlobalConfiguration.lengthCheckZero
                        ? () => {}
                        : handleClick
                    }
                    btnText={icon === ICONS?.ARROW_UP_WHITE ? "Show" : "Hide"}
                    btnType="button"
                    isDisabled={
                      newTags?.filter((fil) => !fil.selected).length ===
                      GlobalConfiguration.lengthCheckZero
                    }
                    enabledBgColor={"var(--primary-bg)"}
                    isLoading={false}
                    hoverOption="white"
                    enabledTextColor={"var(--text-primary)"}
                    icon={
                      icon === ICONS?.ARROW_DOWN_WHITE
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                    }
                    imgColor={"var(--text-primary)"}
                    iconToBeAlign="right"
                    fullWidthRequired={false}
                  />
                </div>
              </div>
            </div>
            <div
              className={`w-full h-full relative border-l-border lg:flex border-primary-bg flex-col flex ${
                users && !services?.includes("CTag")
                  ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none"
                  : !users && !services?.includes("COwnerTag")
                    ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none"
                    : newTags?.some((tag) => {
                          return tag.selected === false;
                        })
                      ? "bg-PopUp-BackDrop opacity-light-opacity pointer-events-none"
                      : ""
              } ${showUnassignTag ? "flex" : "hidden"} `}
            >
              <div className=" flex flex-col gap-gap-xs px-padding-md pt-padding-md">
                <div className="flex justify-between gap-gap-md ">
                  <div className=" flex gap-gap-sm">
                    {" "}
                    <div className="flex flex-col gap-gap-xs">
                      <p className="text-font-md text-text-primary font-semibold flex items-center justify-start">
                        {description?.title2
                          ? description?.title2
                          : "Unassigned tags"}{" "}
                        -{" "}
                        {filteredExistingTags1?.length ||
                          GlobalConfiguration.lengthCheckZero}
                      </p>
                      {AllTags?.filter(
                        (fill) =>
                          !newTags.some((data) => data?.value === fill?.value),
                      )?.length !== GlobalConfiguration.lengthCheckZero ? (
                        <>
                          {filteredExistingTags1.length >
                          GlobalConfiguration.lengthCheckZero ? (
                            <span className="font-normal text-text-secondary text-font-xs pb-padding-sm">
                              {description?.title3
                                ? description?.title3
                                : users
                                  ? 'Select tag(s) and click "Assign" to link them to the user(s).'
                                  : 'Select tag(s) and click "Assign" to link them to the owner account(s).'}
                            </span>
                          ) : (
                            <span
                              className="font-normal text-text-secondary text-font-sm pb-padding-sm"
                              style={{
                                visibility:
                                  filteredExistingTags1.length ===
                                    GlobalConfiguration.lengthCheckZero &&
                                  "hidden",
                              }}
                            >
                              ""
                            </span>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  <div className="flex-shrink-0 ">
                    <SecondaryRightIconSmallButton
                      btnText="Select all"
                      btnType="button"
                      handleFunction={
                        icon1 === ICONS?.ARROW_DOWN_WHITE ||
                        filteredExistingTags1?.length ===
                          GlobalConfiguration.lengthCheckZero
                          ? () => {}
                          : selectedValue1
                      }
                      isDisabled={
                        icon1 === ICONS?.ARROW_DOWN_WHITE ||
                        loading ||
                        filteredExistingTags1?.length ===
                          GlobalConfiguration.lengthCheckZero
                      }
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor={
                        selectAll1 &&
                        filteredExistingTags1?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-bg)"
                          : "var(--primary-nav)"
                      }
                      hoverOption={
                        selectAll1 &&
                        filteredExistingTags1?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "black"
                          : "white"
                      }
                      icon={
                        selectAll1 &&
                        filteredExistingTags1?.length !==
                          GlobalConfiguration.lengthCheckZero
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className=" flex flex-col gap-gap-xs pl-padding-md pt-padding relative flex-1 pt-padding-md overflow-hidden">
                {loading ? (
                  <>
                    <div className="flex justify-center items-center h-full">
                      <img
                        src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
                        alt="loading"
                        className={` w-icon-lg h-icon-lg`}
                      />
                    </div>
                  </>
                ) : AllTags?.filter(
                    (fill) =>
                      !newTags.some((data) => data?.value === fill?.value),
                  )?.length === GlobalConfiguration.lengthCheckZero ? (
                  <div className="flex flex-col justify-center items-center gap-gap-sm py-padding-md flex-1  h-full">
                    <img
                      className="h-graphic-square-height-sm  "
                      src={
                        "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                      }
                      alt="nolablefound"
                    />
                    <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                      {description?.title8
                        ? description?.title8
                        : " No unassigned tags found."}
                    </p>
                  </div>
                ) : (
                  <>
                    {filteredExistingTags1?.length >
                      GlobalConfiguration.lengthCheckZero &&
                    AllTags?.length > GlobalConfiguration.lengthCheckZero &&
                    !loading ? (
                      <div className="flex gap-gap-sm flex-wrap overflow-y-auto pr-padding-md pb-padding-sm  Qsmd:max-h-full overflow-x-hidden">
                        {AllTags.filter((fil) =>
                          normalize(fil.value).includes(
                            normalize(tagSearchName),
                          ),
                        )
                          .filter(
                            (filter) =>
                              !newTags.some(
                                (data) => data?.value === filter?.value,
                              ),
                          )
                          .map((tag) => (
                            // <PrimaryWithIconButton
                            //   key={tag.value}
                            //   handleFunction={() =>
                            //     handleExistingTag1(tag?.value)
                            //   }
                            //   btnText={tag?.value}
                            //   btnType="button"
                            //   isDisabled={false}
                            //   enabledBgColor={
                            //     tag.selected === false
                            //       ? "var(--positive-card)"
                            //       : "var(--primary-nav-act)"
                            //   }
                            //   isLoading={false}
                            //   hoverOption={
                            //     tag.selected === false ? "black" : "white"
                            //   }
                            //   enabledTextColor="var(--text-primary)"
                            //   icon={
                            //     tag.selected === false
                            //       ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                            //       : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                            //   }
                            //   iconToBeAlign="right"
                            //   fullWidthRequired={false}
                            // />
                            <Chips
                              key={tag.value}
                              txtChip={tag?.value}
                              icon={
                                tag.selected === false
                                  ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                  : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg"
                              }
                              hoverOptionBtn={
                                tag.selected === false ? "black" : "white"
                              }
                              enabledBgColor={
                                tag.selected === false
                                  ? "var(--positive-card)"
                                  : "var(--primary-nav-act)"
                              }
                              isDisabled={false}
                              handleFunctionBtn={() =>
                                handleExistingTag1(tag?.value)
                              }
                              enabledTextColor="var(--text-primary)"
                              isTickerRequired={true}
                            />
                          ))}
                      </div>
                    ) : (
                      <div className="flex flex-col justify-center items-center gap-gap-sm py-padding-md flex-1  h-full">
                        {filteredExistingTags1?.length ===
                          GlobalConfiguration.lengthCheckZero &&
                        tagSearchName.length >
                          GlobalConfiguration.lengthCheckZero ? (
                          <>
                            <img
                              className="h-graphic-square-height-sm  "
                              src={
                                "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                              }
                              alt="nolablefound"
                            />
                            <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                              {description?.title8
                                ? description?.title8
                                : "No unassigned tags found."}
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              className="h-graphic-square-height-sm  "
                              src={
                                "https://q2pay.in/new_assets/graphics/general/unassign.svg"
                              }
                              alt="nolablefound"
                            />
                            <p className="text-text-secondary text-font-xs font-normal pb-padding-sm Qmd:pb-padding-base">
                              {description?.title8
                                ? description?.title8
                                : "No unassigned tags found."}
                            </p>
                          </>
                        )}
                      </div>
                    )}
                  </>
                )}
                <div
                  className={`absolute ${showHideTwo ? "top-top-base" : "top-full"} w-full left-left-base h-full bg-primary-nav transition-all duration-animation-fast  ease-in-out border-b-border border-primary-bg`}
                >
                  {icon1 === ICONS?.ARROW_DOWN_WHITE ? (
                    <div className="flex gap-gap-sm flex-wrap overflow-y-auto pl-padding-md pt-padding-md pr-padding-md pb-padding-sm max-h-full">
                      {AllTags?.map((tag) => {
                        return (
                          <>
                            {!tag.selected && (
                              <Chips
                                key={tag?.value}
                                txtChip={tag.value}
                                icon={
                                  "https://q2pay.in/new_assets/common/view_all/close_with_blue_circle.svg"
                                }
                                hoverOption="white"
                                enabledBgColor="var(--primary-nav-act)"
                                handleFunction={() =>
                                  handleSelectandDeselect1(tag.value)
                                }
                                enabledTextColor="var(--text-primary)"
                              />
                            )}
                          </>
                        );
                      })}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="flex w-full justify-between  relative bg-primary-nav  p-padding-md rounded-br-border-radius-md z-z-index-header">
                <div className="flex gap-gap-sm items-center">
                  <CommonCountMultiSelect
                    bgColor={"bg-primary-bg"}
                    textColor={"text-text-primary"}
                    count={
                      !loading
                        ? AllTags?.filter((fil) => !fil.selected)?.length ||
                          GlobalConfiguration.lengthCheckZero
                        : GlobalConfiguration.lengthCheckZero
                    }
                  />
                  <p className="text-text-primary text-font-sm font-normal hidden Qsmd:block">
                    {description?.title5 ? description?.title5 : "Selected"}
                  </p>
                </div>
                <div className="flex flex-row-reverse gap-gap-sm">
                  <div>
                    <PrimaryButton
                      btnText={"Assign"}
                      btnType={"button"}
                      handleFunction={() => {
                        if (
                          isAnyTagDeselectedUnassign &&
                          !loading &&
                          !tagSearchName?.length
                        ) {
                          handleAssign();
                        }
                      }}
                      isDisabled={
                        !isAnyTagDeselectedUnassign ||
                        loading ||
                        tagSearchName?.length
                      }
                      enabledTextColor={"var(--text-primary)"}
                      enabledBgColor={"var(--positive-act)"}
                      disabledBgColor={"var(--text-disabled)"}
                      hoverOption={"black"}
                      isLoading={false}
                      inActiveVariantNeeded={
                        !isAnyTagDeselectedUnassign || loading
                      }
                      isLoaderNeeded={false}
                    />
                  </div>

                  <PrimaryButton
                    btnText={"Clear"}
                    handleFunction={() => {
                      if (
                        isAnyTagDeselectedUnassign &&
                        !loading &&
                        !tagSearchName?.length
                      ) {
                        clearTags1();
                      }
                    }}
                    isDisabled={
                      !isAnyTagDeselectedUnassign || tagSearchName?.length
                    }
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"transparent"}
                    outLineColor={"var(--text-primary)"}
                    hoverOption="white"
                    btnType="button"
                    isLoading={false}
                    inActiveVariantNeeded={false}
                    isLoaderNeeded={false}
                  />
                  <div className=" border-l-border border-primary-bg"></div>
                  <PrimaryWithIconButton
                    handleFunction={
                      AllTags?.filter((fil) => !fil.selected).length ===
                      GlobalConfiguration.lengthCheckZero
                        ? () => {}
                        : handleClick1
                    }
                    btnText={icon1 === ICONS?.ARROW_UP_WHITE ? "Show" : "Hide"}
                    btnType="button"
                    isDisabled={
                      AllTags?.filter((fil) => !fil.selected).length ===
                      GlobalConfiguration.lengthCheckZero
                    }
                    enabledBgColor={"var(--primary-bg)"}
                    isLoading={false}
                    hoverOption="white"
                    enabledTextColor={"var(--text-primary)"}
                    icon={
                      icon1 === ICONS?.ARROW_DOWN_WHITE
                        ? "https://q2pay.in/new_assets/common/arrows/arrow_down_white.svg"
                        : "https://q2pay.in/new_assets/common/arrows/arrow_up_white.svg"
                    }
                    imgColor={"var(--text-primary)"}
                    iconToBeAlign="right"
                    fullWidthRequired={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonAssignTagPopup;
